import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ClickOutsideDirective } from '../directives/click-outside.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AuthService } from '../../auth/services/auth.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'buton-user-profile',
  standalone: true,
  imports: [CommonModule, ClickOutsideDirective, MatIconModule, MatMenuModule, MatCheckboxModule, RouterModule],
  templateUrl: './buton-user-profile.component.html',
  styleUrl: './buton-user-profile.component.scss'
})
export class ButonUserProfileComponent implements AfterViewInit {

  @Input() label!:string;

  @Input() data!:any;

  @Output() dataSelected = new EventEmitter<any>();
  
  dataFilter: any=[];

  authService = inject(AuthService); 



  @ViewChild('menu') menu!: ElementRef;
  @ViewChild('button') button!: ElementRef;

  constructor() {}


  ngOnChanges(changes: SimpleChanges): void {
    
  }

  selected(id: number){
    this.dataFilter= this.dataFilter.map( (item: any) =>{
      if (item.id === id) {
        return {...item, selected: !item.selected}
      } else {
        return item;
        
      }
    });

    let data = this.dataFilter.filter((item: any) => item.selected === true);
    this.dataSelected.emit(data);
  }


  ngAfterViewInit() {
  }

  logOut() {
    this.authService.logoOut();

  }


  
}
